export interface DictionaryACTypeEntity {
  id: number;
  icaoType: string;
  iataType: string;
  tankCapacity: number;
  minOnBlockDiff: string;
  maxOnBlockDiff: string;
  sched: string | null | undefined;
  avgFuelConsPerBh: number | null | undefined;
}
